import moment from 'moment';

import { DATE_FORMAT_FOR_UI } from 'Common/Constants';
import { UpdateBidDetailsEnum } from 'Common/FieldEnum';

import * as types from './types';

const INITIAL_STATE = {
  bidDetailsData: {
    BidPriceDetails: [],
    BidPriceBeginDate: null,
    BidPriceEndDate: null,
  },
  loadingBidDetails: false,
  bidDetailsLoadingError: null,
  isSubmittingBidPrice: false,
  submitted: false,
  submitError: null,
  printData: '',
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case types.BID_DETAILS_LOADING:
      return {
        ...state,
        loadingBidDetails: action.payload,
      };

    case types.BID_DETAILS_DATA:
      const bidDetailsData = action.payload;

      bidDetailsData.BidPriceDetails.map(bidItem => {
        bidItem[UpdateBidDetailsEnum.BidPriceEndDate] = moment(
          bidItem[UpdateBidDetailsEnum.BidPriceEndDate]
        ).format(DATE_FORMAT_FOR_UI);
        bidItem.BeginDT = moment(bidItem.BeginDT).format(DATE_FORMAT_FOR_UI);
        bidItem[UpdateBidDetailsEnum.PrimaryPrice] = Number(
          bidItem[UpdateBidDetailsEnum.PrimaryPrice]
        ).toFixed(4);
        return bidItem;
      });

      return {
        ...state,
        bidDetailsData,
        submitted: false,
      };

    case types.BID_DETAILS_LOADING_ERROR:
      return {
        ...state,
        bidDetailsLoadingError: action.payload,
      };

    case types.CLEAR_BID_DETAILS_ERROR:
      return {
        ...state,
        submitError: null,
        bidDetailsLoadingError: null,
      };

    case types.UPDATING_BID_DETAILS:
      return {
        ...state,
        isSubmittingBidPrice: action.payload,
      };

    case types.BID_DETAIL_SUBMIT:
      return {
        ...state,
        submitted: true,
      };

    case types.BID_DETAIL_SUBMIT_ERROR:
      return {
        ...state,
        submitError: action.payload,
      };

    case types.SET_BID_DETAIL_PRINT_DATA:
      return {
        ...state,
        printData: action.payload,
      };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/pages/utilities/state/updateBidDetails/reducer.js